import { Link } from "react-router-dom";

const shouldHideSupportButton = (
  search: string = window.location.search,
): boolean => {
  const searchParams = new URLSearchParams(search);

  const hideParams = ["billing/choose-plan"];

  return hideParams.some((param) => searchParams.has(param));
};

const year = new Date().getFullYear();

const Footer = () => {
  const hideSupport = shouldHideSupportButton();

  return (
    <div className="my-3 mt-5 pb-3 text-center text-[11.5px] text-[var(--mute)]">
      © {year} Neo by Nethority. All rights reserved
      {!hideSupport && (
        <>
          {" "}
          |{" "}
          <Link
            to="/support"
            className="text-[var(--accent2)] hover:underline"
          >
            Support
          </Link>
        </>
      )}
    </div>
  );
};

export default Footer;
